import { useMemo, type ReactNode } from "react";

/**
 * Calculates a responsive font size based on the container size and text length.
 *
 * @param size - The base size of the container.
 * @param textLength - The number of characters in the text.
 * @returns A CSS clamp value representing the calculated font size.
 */
const fontSize = (size: number, textLength: number) => {
  return `clamp(${size * 0.2}px, ${(size * 0.7) / Math.sqrt(textLength)}px, ${size * 0.6}px)`;
};

/**
 * Computes responsive font size for text content inside a circle element.
 * Returns undefined for non-text children (SVG, elements, etc).
 */
export const useCircleFontSize = (size: number, children: ReactNode): string | undefined => {
  return useMemo(() => {
    if (typeof children === "string") return fontSize(size, children.length);
    if (typeof children === "number") return fontSize(size, children.toString().length);
    return undefined;
  }, [size, children]);
};
